import { useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { AudienceForm, GroupLike } from '../../../types';
import { getNestedError } from '../../../utils/getNestedError';
import { hasAnySegments } from '../../../utils/validateNormalizedDefinition';

type CriteriaError = { message?: string } | undefined;

export const useCriteriaErrors = () => {
  const {
    formState: { errors, isSubmitted },
  } = useFormContext<AudienceForm>();

  const observableIncludesGroups = useWatch({ name: 'normalized_definition.includes.groups' }) as
    | GroupLike[]
    | undefined;
  const observableExcludesGroups = useWatch({ name: 'normalized_definition.excludes.groups' }) as
    | GroupLike[]
    | undefined;

  const everHadIncludesSegments = useRef(false);
  const everHadExcludesSegments = useRef(false);

  if (hasAnySegments(observableIncludesGroups ?? [])) everHadIncludesSegments.current = true;
  if (hasAnySegments(observableExcludesGroups ?? [])) everHadExcludesSegments.current = true;

  const rawIncludesError: CriteriaError = getNestedError(errors, 'normalized_definition.includes.groups');
  const rawExcludesError: CriteriaError = getNestedError(errors, 'normalized_definition.excludes.groups');

  const includesError = isSubmitted || everHadIncludesSegments.current ? rawIncludesError : undefined;
  const excludesError = isSubmitted || everHadExcludesSegments.current ? rawExcludesError : undefined;

  return { includesError, excludesError };
};
